import { useEffect } from 'react';

/**
 * Custom hook to set the page title
 * @param {string} title - The specific page title
 * @param {boolean} includeAppName - Whether to include the app name, defaults to true
 */
function usePageTitle(title, includeAppName = true) {
  useEffect(() => {
    // Set document title with or without app name
    const appName = 'ChatOdyssey - Virtual Identity Engine';
    document.title = includeAppName ? `${title} | ${appName}` : title;
    
    // Clean up when component unmounts
    return () => {
      document.title = appName;
    };
  }, [title, includeAppName]);
}

export default usePageTitle; 